import * as React from "react";

export const Energy = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3353 5.375C12.8417 5.375 13.1794 5.94922 12.898 6.35938L7.94584 14.6719C7.83329 14.8906 7.60819 15 7.35495 15C6.93289 15 6.62338 14.6172 6.70779 14.207L8.00211 8.875H4.68191C4.25985 8.875 3.95034 8.54688 4.00661 8.13672L4.90701 1.57422C4.93514 1.24609 5.24465 1 5.5823 1H9.63407C10.0561 1 10.3938 1.41016 10.2812 1.84766L9.07133 5.375H12.3353Z"
    />
);
